import { format } from 'date-fns'

export function getDateForFilename(date: Date | number = new Date()) {
  return format(date, "yyyy-MM-dd-'T'HHmmss")
}
